module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAwCAYAAAAy7wv4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANlJREFUeNrEkz0PgjAQhltQQVHD5mDi4sLipIMJi///7/iFCuq9+l7SgSNh0SYP195DuPZIvXMuChjo3MsjJkMCGfsgMRJSxqHnRJMTxgQiIWNhSvkRKQUSMyFTsRduwlk4ChesIXYUSJyEq4oNRUWJeIdYCw8sNIk1xEJohJovgAZiLjxJrfPO7ZoHNFtiNtFsu/mjzO2aBzRb0tpE7GblvkNr4LONildQo9YaKcmCXqV/F7lrGRBLSxSW2FqitMShtyh7Fy96HzDvKl4FdxCxipwxfiHeAgwAKlpFtigygOYAAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/shared/shadow.png
 ** module id = 478
 ** module chunks = 0
 **/